
































































































import { Component, Vue } from 'vue-property-decorator';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { patrolManagementServe } from '@/api/installServer';
import { TableStripe } from '@/mixins/tableStripe';
import detailPage from '@/views/patrolManagement/devicePatrolTask/unit/detailPage.vue';
import PagingUnit from '@/components/paging/paging.vue';
import TreeUnit from '@/components/tree/treeUnit.vue';
import Axios from 'axios';
import publishObjectPath from '@/util/configRegistry';

const serverUrl = publishObjectPath.serverUrl;

@Component({
  components: { CollapseTransition, detailPage, PagingUnit, TreeUnit },
  mixins: [TableStripe],
})
export default class PatrolTask extends Vue {
  private selectList: any = [];
  private openAsideFlag = false; // 侧边栏是否打开
  private showFlag = 1;
  private row: any = {
    id: '',
  };
  private queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  private total = 0; // 数据总共多少条

  private searchForm: any = {
    search: '',
    status: null,
    date: [],
  };
  private formShow = false; // 是否显示表单搜索

  private tableData: any = [];

  handleTableSelectionChange(val: any) {
    this.selectList = val;
  }

  showTree(flag: boolean) {
    this.openAsideFlag = flag;
  }

  getNodeIds(data: any) {
    this.getAllData();
  }

  handleAddBtnClick() {}

  handleTableDetailBtnClick(data: any) {
    this.row.id = data.id;
    this.showFlag = 2;
  }

  handleInfoResponse() {
    this.showFlag = 1;
    this.getAllData();
  }

  handleBatchCommand(command: string) {
    if (this.selectList.length === 0) {
      this.$message.warning('请选择您要操作的数据。');
      return;
    }
    switch (command) {
      case 'remove':
        this.handleBatchRemove();
        break;
      case 'export':
        this.handleBatchExport();
        break;
      case 'finish':
        this.handleBatchFinish();
        break;
    }
  }

  handleBatchRemove() {
    this.$confirm('此操作将永久删除, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        const _selectList = this.selectList.map((item: any) => item.id);
        console.log(_selectList);
        this.removeTaskData(_selectList);
      })
      .catch(() => {});
  }
  handleBatchExport() {
    // 服务加载的动画
    const loading = this.$loading({
      lock: true,
      text: '下载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    });
    const _selectList = this.selectList.map((item: any) => item.id);
    Axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8';
    Axios.defaults.headers.Authorization = localStorage.getItem('token');
    Axios({
      method: 'POST',
      url: serverUrl + '/api/yunnan/devicePatrolTask/export/excel', // 请求地址
      responseType: 'blob', // 表明返回服务器返回的数据类型
      data: {
        search: this.searchForm.search ? this.searchForm.search : null,
        topDepartmentName: this.searchForm.topDepartmentName ? this.searchForm.topDepartmentName : null,
        startDate: this.searchForm.date[0] ? this.searchForm.date[0] : null,
        endDate: this.searchForm.date[1] ? this.searchForm.date[1] : null,
        pageNo: (this.queryDataForm as any).pageNo,
        pageSize: (this.queryDataForm as any).pageSize,
        ids: _selectList,
      },
    })
      .then(response => {
        // const disposition = response.headers["Content-disposition"];
        console.log(response);
        let fileName = '导出文件';
        try {
          const disposition = response.headers['content-disposition'];
          console.log(disposition);
          fileName = decodeURIComponent(disposition.split('filename = ')[1]); // 中文需要转码 (前端乱码为百分号形式）
        } catch (error) {
          fileName = '导出文件';
        }
        const blob = response.data;
        const a = document.createElement('a');
        a.download = fileName;
        a.style.display = 'none';
        a.href = URL.createObjectURL(blob);
        document.body.appendChild(a); // 修复firefox中无法触发click
        a.click();
        document.body.removeChild(a);
        loading.close();
        this.$message({
          type: 'success',
          message: '导出成功!',
        });
      })
      .catch(error => {
        loading.close();
        this.$message({
          type: 'error',
          message: '导出失败,请联系管理员!',
        });
        console.log(error);
      });
  }

  handleTableDeleteBtnClick(data: any) {
    this.$confirm('此操作将永久删除该任务, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then((ctx: any) => {
        this.removeTaskData(data.id);
      })
      .catch((e: any) => {});
  }

  async removeTaskData(ids: any) {
    try {
      const res: any = await patrolManagementServe.devicePatrolTaskDelete(ids);
      if (res.code === '200') {
        this.$message.success('删除成功。');
      } else {
        this.$message.warning(res.msg);
      }
      this.getAllData();
    } catch (e) {
      this.$message.warning('删除失败。');
      throw new Error();
    }
  }

  getListData() {
    this.getAllData();
  }

  created() {
    // 获取所有数据
    this.getAllData();
  }

  getAllData() {
    patrolManagementServe
      .devicePatrolTaskList({
        search: this.searchForm.search ? this.searchForm.search : null,
        topDepartmentName: this.searchForm.topDepartmentName ? this.searchForm.topDepartmentName : null,
        startDate: this.searchForm.date[0] ? this.searchForm.date[0] : null,
        endDate: this.searchForm.date[1] ? this.searchForm.date[1] : null,
        pageNo: (this.queryDataForm as any).pageNo,
        pageSize: (this.queryDataForm as any).pageSize,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      })
      .catch((error: any) => {
        this.$message.error('查询失败,请稍后重试!');
      });
  }

  search() {
    // 获取到符合搜索条件的数据
    (this.queryDataForm as any).pageNo = 1;
    this.getAllData();
  }

  resetForm() {
    (this.$refs.formRef as any).resetFields();
    (this.queryDataForm as any).pageNo = 1;
    this.searchForm = {
      search: '',
      status: null,
      date: [],
    };
    // 获取全部数据
    this.getAllData();
  }

  setFormShow() {
    this.formShow = !this.formShow;
  }

  handleBatchFinish() {
    this.$prompt('请填写检修完成的原因', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputType: 'textarea',
    })
      .then((value: any) => {
        // console.log(value, value.value);
        if (!value.value) {
          this.$message({
            type: 'warning',
            message: '请填写检修完成的原因！',
          });
        } else {
          const _selectList = this.selectList.map((item: any) => item.id);
          this.finishTaskData(_selectList, value.value);
        }
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入',
        });
      });
  }

  /**
   * 【接口】删除巡检任务
   * @param ids {String} 用户id
   */
  async finishTaskData(ids: string | string[], value: any) {
    try {
      const res: any = await patrolManagementServe.finishEquipPatrol({
        finishWay: '检修完成',
        reason: value,
        taskIdList: ids,
      });
      if (res.code === '200') {
        this.$message.success('任务检修完成成功。');
      } else {
        this.$message.warning('任务检修完成失败。');
      }
      this.getAllData();
    } catch (e) {
      this.$message.warning('任务检修完成失败。');
      throw new Error();
    }
  }
}
